import { render, staticRenderFns } from "./ApiDocument.vue?vue&type=template&id=8fc69ed6"
import script from "./ApiDocument.vue?vue&type=script&lang=js"
export * from "./ApiDocument.vue?vue&type=script&lang=js"
import style0 from "./ApiDocument.vue?vue&type=style&index=0&id=8fc69ed6&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports